module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-03"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "pt-5": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Flujo positivo y negativo',
      "videoEmbed": "ADMINISTRACIONDINERO14FlujoPositivoNegativo (ant45).mp4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "hidden-xs-only",
    attrs: {
      "xs12": "",
      "sm3": "",
      "text-xs-right": "",
      "mt-2": "",
      "hidden-xs-only": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "imaSize": 120,
      "imaSrc": "design/red-arrow",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_1",
    attrs: {
      "xs12": "",
      "sm8": "",
      "mt-2": ""
    }
  }, [_c('h1', {
    attrs: {
      "aria-hidden": ""
    }
  }, [_c('span', {
    staticClass: "font-red",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("Los ingresos (entradas) y los egresos (salidas)")]), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("\n        de dinero forman un flujo de efectivo. \n        La diferencia entre las entradas y salidas determina si se cuenta con el flujo"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "davi-curs",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("de efectivo positivo (+) o negativo (-).")])]), _vm._v(" "), _c('p', {
    staticClass: "offscreen"
  }, [_vm._v("Los ingresos (entradas) y los egresos (salidas) de dinero forman el flujo de efectivo. La diferencia entre las entradas y salidas determina si se cuenta con el flujo de efectivo positivo (+) o negativo (-).")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "text-xs-center": "",
      "mt-2": "",
      "hidden-xs-only": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "imaSize": 386,
      "imaSrc": "design/texture",
      "imaAlt": ""
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-559dcf3e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-14.vue
// module id = 984
// module chunks = 1